import { useRouter } from 'next/router';
import { useReduxState } from 'hooks';
import { DropdownSelectable } from 'components/common/dropdown';

import type { ButtonCategory } from './Button';

type Props = {
  buttonStyle?: React.CSSProperties;
  category?: ButtonCategory;
  options: { text: string; value: string }[];
  value: string;
} & (
  | {
      onChange: ({ sortBy }: { sortBy: string }) => void;
      urlKey?: never;
      withUrl?: false;
    }
  | { onChange?: never; urlKey?: string; withUrl: true }
);

const SortBy = ({
  buttonStyle = {},
  category = 'lighter',
  onChange,
  options,
  value,
  urlKey = 'sortBy',
  withUrl = false
}: Props) => {
  const { messages } = useReduxState();

  const router = useRouter();

  const handleChange = (value: string) => {
    onChange({ sortBy: value });
  };

  const handleChangeWithUrl = (value: string) => {
    const query = { ...router.query };
    if (query.page) query.page = '1';

    if (value) query[urlKey] = value;
    else delete query[urlKey];

    router.replace({ query }, undefined, { shallow: true });
  };

  return (
    <DropdownSelectable
      buttonStyle={{ padding: '6px 0', width: 30, height: 30, ...buttonStyle }}
      category={category}
      defaultValue={value}
      dropdownTextMinWidth="120px"
      icon="sort-amount-down"
      iconStyle={{ fontSize: '1.4rem' }}
      label={messages.commonSort}
      onChange={withUrl ? handleChangeWithUrl : handleChange}
      options={options}
      showArrow={false}
      size="medium"
      tooltip={messages.commonSort}
    />
  );
};

export default SortBy;
